'use strict';

exports.__esModule = true;
var ACCOUNTS = exports.ACCOUNTS = {
  BASICINFO: {
    LOADING: 'BASICINFO_LOADING',
    SUCCEEDED: 'BASICINFO_SUCCEEDED',
    FAILED: 'BASICINFO_FAILED'
  },
  Add_USER_ACCOUNT: {
    LOADING: 'Add_USER_ACCOUNT_LOADING',
    SUCCEEDED: 'Add_USER_ACCOUNT_SUCCEEDED',
    FAILED: 'Add_USER_ACCOUNT_FAILED'
  },
  EDIT_USER_ACCOUNTS: {
    LOADING: 'EDIT_USER_ACCOUNTS_LOADING',
    SUCCEEDED: 'EDIT_USER_ACCOUNTS_SUCCEEDED',
    FAILED: 'EDIT_USER_ACCOUNTS_FAILED'
  },
  UPDATE_LOGIN_STATUS: {
    LOADING: 'UPDATE_LOGIN_STATUS_LOADING',
    SUCCEEDED: 'UPDATE_LOGIN_STATUS_SUCCEEDED',
    FAILED: 'UPDATE_LOGIN_STATUS_FAILED'
  },
  SEARCH_ACCOUNTS: {
    LOADING: 'SEARCH_ACCOUNTS_LOADING',
    SUCCEEDED: 'SEARCH_ACCOUNTS_SUCCEEDED',
    FAILED: 'SEARCH_ACCOUNTS_FAILED'
  },
  SET_USER_ACCOUNT_INFO: 'SET_USER_ACCOUNT_INFO',
  TOGGLE_FILTER_DROPDOWN: 'TOGGLE_FILTER_DROPDOWN',
  TOGGLE_ADD_USER_MODAL: 'TOGGLE_ADD_USER_MODAL',
  TOGGLE_EDIT_USER_MODAL: 'TOGGLE_EDIT_USER_MODAL',
  TOGGLE_ABOUT_USER_MODAL: 'TOGGLE_ABOUT_USER_MODAL'
};

var getBasicInfo = exports.getBasicInfo = function getBasicInfo(getAccountHeader /*: Array<Object>*/) {
  return {
    type: ACCOUNTS.BASICINFO.LOADING,
    getAccountHeader: getAccountHeader
  };
};

var updateLoginStatus = exports.updateLoginStatus = function updateLoginStatus(payload) {
  return {
    type: ACCOUNTS.UPDATE_LOGIN_STATUS.LOADING,
    payload: payload
  };
};

var updateLoginStatusSuccess = exports.updateLoginStatusSuccess = function updateLoginStatusSuccess(payload) {
  return {
    type: ACCOUNTS.UPDATE_LOGIN_STATUS.SUCCEEDED,
    payload: payload
  };
};

var updateLoginStatusFail = exports.updateLoginStatusFail = function updateLoginStatusFail(payload) {
  return {
    type: ACCOUNTS.UPDATE_LOGIN_STATUS.FAILED,
    payload: payload
  };
};

var addUserAccount = exports.addUserAccount = function addUserAccount(payload) {
  return {
    type: ACCOUNTS.Add_USER_ACCOUNT.LOADING,
    payload: payload
  };
};

var addUserAccountSuccess = exports.addUserAccountSuccess = function addUserAccountSuccess(payload) {
  return {
    type: ACCOUNTS.Add_USER_ACCOUNT.SUCCEEDED,
    payload: payload
  };
};

var addUserAccountFail = exports.addUserAccountFail = function addUserAccountFail(payload) {
  return {
    type: ACCOUNTS.Add_USER_ACCOUNT.FAILED,
    payload: payload
  };
};

var editUserAccount = exports.editUserAccount = function editUserAccount(payload) {
  return {
    type: ACCOUNTS.EDIT_USER_ACCOUNTS.LOADING,
    payload: payload
  };
};

var editUserAccountSuccess = exports.editUserAccountSuccess = function editUserAccountSuccess(payload) {
  return {
    type: ACCOUNTS.EDIT_USER_ACCOUNTS.SUCCEEDED,
    payload: payload
  };
};

var editUserAccountFail = exports.editUserAccountFail = function editUserAccountFail(payload) {
  return {
    type: ACCOUNTS.EDIT_USER_ACCOUNTS.FAILED,
    payload: payload
  };
};

var searchAccounts = exports.searchAccounts = function searchAccounts(payload) {
  return {
    type: ACCOUNTS.SEARCH_ACCOUNTS.LOADING,
    payload: payload
  };
};

var searchAccountsSuccess = exports.searchAccountsSuccess = function searchAccountsSuccess(payload) {
  return {
    type: ACCOUNTS.SEARCH_ACCOUNTS.SUCCEEDED,
    payload: payload
  };
};

var searchAccountsFail = exports.searchAccountsFail = function searchAccountsFail(payload) {
  return {
    type: ACCOUNTS.SEARCH_ACCOUNTS.FAILED,
    payload: payload
  };
};

var setUserAccountInfo = exports.setUserAccountInfo = function setUserAccountInfo(payload) {
  return {
    type: ACCOUNTS.SET_USER_ACCOUNT_INFO,
    payload: payload
  };
};

var toggleFilterDropDown = exports.toggleFilterDropDown = function toggleFilterDropDown(payload) {
  return {
    type: ACCOUNTS.TOGGLE_FILTER_DROPDOWN,
    payload: payload
  };
};

var toggleAddUserModal = exports.toggleAddUserModal = function toggleAddUserModal(payload) {
  return {
    type: ACCOUNTS.TOGGLE_ADD_USER_MODAL,
    payload: payload
  };
};

var toggleEditUserModal = exports.toggleEditUserModal = function toggleEditUserModal(payload) {
  return {
    type: ACCOUNTS.TOGGLE_EDIT_USER_MODAL,
    payload: payload
  };
};

var toggleAboutUserModal = exports.toggleAboutUserModal = function toggleAboutUserModal(payload) {
  return {
    type: ACCOUNTS.TOGGLE_ABOUT_USER_MODAL,
    payload: payload
  };
};